import React, { RefObject } from 'react';

import { Spinner } from '@rbilabs/universal-components';
import { StyleSheet } from 'react-native';

import { Box } from 'components/ui';
import { useIsDesktopBreakpoint } from 'hooks/use-media-query';
import { t } from 'state/intl/translations';
import { primitive, spacing } from 'styles/constants';

import { DeliveryAddressSelectHandle } from './delivery-addresses';
import { DeliveryAddressFormHandle } from './new-address-form';
import { DeliveryAddressFormFooter } from './new-address-form/delivery-address-form-footer';
import { DeliverHereButton } from './styled';
import { ActionStatus } from './types';

const BUTTON_CONTAINER_MAX_WIDTH = 576;

type DeliveryAddressesButtonsProps = {
  status: ActionStatus;
  selected: string;
  selectRef: RefObject<DeliveryAddressSelectHandle | null>;
};
const DeliveryAddressesButtons = ({
  selectRef,
  status,
  selected,
}: DeliveryAddressesButtonsProps) => {
  const isLoading = status === ActionStatus.PENDING;
  const isDesktop = useIsDesktopBreakpoint();

  const handleOnDeliveryHereButton = () => {
    selectRef.current?.onSelectAddress();
  };

  return (
    <Box
      style={[styles.buttonContainer, isDesktop && styles.buttonContainerDesktop]}
      testID="delivery-addresses-button-container"
    >
      <DeliverHereButton
        testID="select-delivery-address"
        disabled={isLoading || selected === ''}
        onPress={handleOnDeliveryHereButton}
        bg={isLoading || selected === '' ? primitive.$fieryRedOpacity30 : undefined}
        _text={{
          color: isLoading ? primitive.$bbqBrown : primitive.$white,
        }}
        rightIcon={
          isLoading ? (
            <Box style={styles.spinnerWrapper}>
              <Spinner size="sm" color={primitive.$white} />
            </Box>
          ) : undefined
        }
      >
        {t('deliverHere')}
      </DeliverHereButton>
    </Box>
  );
};

type ModalFooterProps = DeliveryAddressesButtonsProps & {
  formRef: RefObject<DeliveryAddressFormHandle | null>;
  showTermsView: boolean;
  showDeliveryAddresses: boolean;
  createAddressView: boolean;
  isEditing: boolean;
  isDisabled: boolean;
  showTermsLink: boolean;
};
export const ModalFooter = ({
  formRef,
  status,
  showTermsView,
  selectRef,
  selected,
  showDeliveryAddresses,
  createAddressView,
  isEditing,
  isDisabled,
  showTermsLink,
}: ModalFooterProps) => {
  if (status === ActionStatus.QUOTE_UNAVAILABLE || showTermsView) {
    return null;
  }

  if (!createAddressView && showDeliveryAddresses) {
    return <DeliveryAddressesButtons status={status} selectRef={selectRef} selected={selected} />;
  }

  return (
    <DeliveryAddressFormFooter
      isEditing={isEditing}
      submitAddress={() => formRef.current?.handleSubmit()}
      isDisabled={isDisabled}
      isLoading={status === ActionStatus.PENDING}
      showtermsLink={showTermsLink}
    />
  );
};

const styles = StyleSheet.create({
  buttonContainer: {
    alignSelf: 'center',
    marginVertical: spacing.$4,
    maxWidth: BUTTON_CONTAINER_MAX_WIDTH,
    paddingHorizontal: spacing.$4,
    width: '100%',
  },
  buttonContainerDesktop: {
    width: '50%',
  },
  spinnerWrapper: {
    alignItems: 'center',
    height: spacing.$4,
    justifyContent: 'center',
    width: spacing.$4,
  },
});
